<template>
  <div class="setPassword">
    <h1 class="title">账号安全设置</h1>
    <div style="width:340px;margin:0 auto;" class="change-loginPass">
      <div>
        <h3 style="text-align:center;font-size:18px;font-weight:normal;color:#333333;margin-bottom:40px;padding-top:10px;">修改密码</h3>
        <el-form :model="passChange" ref="passChange" :rules="rules" label-width="0px" class="passChange">
          <el-form-item prop="oldPass">
            <el-input v-model="passChange.oldPass" placeholder="请输入旧密码" type="password" auto-complete="new-password"></el-input>
          </el-form-item>
          <el-form-item prop="newPass">
            <el-input v-model="passChange.newPass" placeholder="请输入新密码" type="password" auto-complete="new-password"></el-input>
          </el-form-item>
          <el-form-item prop="confirmPass">
            <el-input v-model="passChange.confirmPass" placeholder="确认新密码" type="password" auto-complete="new-password"></el-input>
          </el-form-item>
          <div style="text-align:center;">
            <el-button type="primary" style="width:100px;background:#1060ab;font-size:16px;margin-top:33px;" @click="changeSuccess">完成</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    const oldPasswordCheck = (rule, value, callback) => {
      this.$ajax
        .post(
          "/comuser-service/Account/findUpdatePassword",
          this.postData({
            id: sessionStorage.userUuid,
            usedPassword: this.passChange.oldPass
          })
        )
        .then(res => {
          if (res.code === "-10") {
            callback(new Error(res.message));
          } else {
            callback()
          }
        });
    }
    const pwCheck = (rule, value, callback) => {
      if (!this.passChange.newPass) {
        callback(new Error("请输入新密码"));
      } else if (this.passChange.oldPass === this.passChange.newPass) {
        callback(new Error("新旧密码不能重复"));
      } else if (
        !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(
          this.passChange.newPass
        )
      ) {
        callback(new Error("请输入8-16位，数字和字母的组合"));
      } else {
        callback();
      }
    }
    const rePwCheck = (rule, value, callback) => {
      if (
        !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(
          this.passChange.newPass
        )
      ) {
        callback(new Error("密码格式错误"));
      } else if (
        this.passChange.newPass !== this.passChange.confirmPass
      ) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    }
    return {
      passChange: {
        oldPass: '',
        newPass: '',
        confirmPass: ''
      },
      rules: {
        oldPass: [
          {required: true, message: "请输入旧密码", trigger: "blur"},
          { validator: oldPasswordCheck, trigger: "blur" }
        ],
        newPass: [
          // {required: true, message: '请输入密码', trigger: 'blur'},
          { required: true, validator: pwCheck, trigger: "blur" }
        ],
        confirmPass: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: rePwCheck, trigger: "blur" }
        ]
      }
    }
  },
  created () {
    if (sessionStorage.whichWay !== 'pass') {
      this.$router.push('/trainClass/personalCenter/accountInfo/accountSafty')
    }
  },
  mounted () {
  },
  methods: {
    changeSuccess () {
      this.$refs['passChange'].validate(valid => {
        if (valid) {
          this.$ajax
            .post(
              '/comuser-service/Account/updatesPasswordByPassWord',
              this.postData({
                id: sessionStorage.userUuid,
                newPassword: this.passChange.newPass
              })
            )
            .then(res => {
              if ((res.code === '200')) {
                debugger
                this.$message({
                  message: "密码修改成功",
                  type: "success"
                })
                setTimeout(() => {
                  sessionStorage.hasChecked = 'changePass'
                  this.$router.push('/trainClass/personalCenter/accountInfo/accountSafty')
                }, 1000)
              } else {
                this.$message.error(res.message)
              }
            })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.setPassword {
  width: 1020px;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  .title {
    font-weight: normal;
    font-size: 24px;
    margin: 30px 40px;
    color: #333333;
    border-bottom:1px solid #eeeeee;
    padding-bottom: 20px;
  }
  .passChange {
    margin-bottom:33px;
    .el-form-item__label {
      font-size: 16px;
      color: #333333;
    }
    .el-input {
      width: 340px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/accountInfo/setPa.vue